import "../chunk-D57E6H3M.mjs";

// src/hooks/useExitPresence.ts
import { useEffect, useState } from "react";
function useExitPresence(value, ref) {
  const [retained, setRetained] = useState(value);
  if (value !== void 0 && value !== retained) setRetained(value);
  const closing = value === void 0 && retained !== void 0;
  useEffect(() => {
    if (!closing) return;
    let cancelled = false;
    const release = () => {
      if (!cancelled) setRetained(void 0);
    };
    const running = ref.current?.getAnimations?.() ?? [];
    Promise.all(running.map((animation) => animation.finished)).then(release, release);
    return () => {
      cancelled = true;
    };
  }, [closing, ref]);
  return { rendered: value ?? retained, closing };
}
export {
  useExitPresence
};
//# sourceMappingURL=useExitPresence.mjs.map